/**
 * master
 *  ## 공통으로 사용되는 데이터를 등록,조회,수정,삭제한다.
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent } from '@angular/common/http';
import { Configuration } from '../configuration';
var CategoriesCodesService = /** @class */ (function () {
    function CategoriesCodesService(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = 'http://bstore-dev-nlb-to-backends-03c7de26a0c53e22.elb.ap-northeast-2.amazonaws.com:9900/master/v1';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    CategoriesCodesService.prototype.canConsumeForm = function (consumes) {
        var form = 'multipart/form-data';
        for (var _i = 0, consumes_1 = consumes; _i < consumes_1.length; _i++) {
            var consume = consumes_1[_i];
            if (form === consume) {
                return true;
            }
        }
        return false;
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdGet = function (category_code_id, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdGet.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/x-www-form-urlencoded'
        ];
        return this.httpClient.get(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdDelete = function (category_code_id, pacode_id, chcode_id, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdDelete.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdDelete.');
        }
        if (chcode_id === null || chcode_id === undefined) {
            throw new Error('Required parameter chcode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdDelete.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/x-www-form-urlencoded'
        ];
        return this.httpClient.delete(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)) + "/chcode/" + encodeURIComponent(String(chcode_id)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdGet = function (category_code_id, pacode_id, chcode_id, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdGet.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdGet.');
        }
        if (chcode_id === null || chcode_id === undefined) {
            throw new Error('Required parameter chcode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdGet.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/x-www-form-urlencoded'
        ];
        return this.httpClient.get(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)) + "/chcode/" + encodeURIComponent(String(chcode_id)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdPut = function (category_code_id, pacode_id, chcode_id, body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdPut.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdPut.');
        }
        if (chcode_id === null || chcode_id === undefined) {
            throw new Error('Required parameter chcode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdPut.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodeChcodeIdPut.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)) + "/chcode/" + encodeURIComponent(String(chcode_id)), body, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdChcodePost = function (category_code_id, pacode_id, body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodePost.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodePost.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdChcodePost.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)) + "/chcode", body, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdGet = function (category_code_id, pacode_id, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdGet.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdGet.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/x-www-form-urlencoded'
        ];
        return this.httpClient.get(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)), {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePacodeIdPut = function (category_code_id, pacode_id, body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdPut.');
        }
        if (pacode_id === null || pacode_id === undefined) {
            throw new Error('Required parameter pacode_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdPut.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling categoriesCodesCategoryCodeIdPacodePacodeIdPut.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode/" + encodeURIComponent(String(pacode_id)), body, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesCategoryCodeIdPacodePost = function (category_code_id, body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (category_code_id === null || category_code_id === undefined) {
            throw new Error('Required parameter category_code_id was null or undefined when calling categoriesCodesCategoryCodeIdPacodePost.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling categoriesCodesCategoryCodeIdPacodePost.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/categories_codes/" + encodeURIComponent(String(category_code_id)) + "/pacode", body, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesGet = function (observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [
            'application/json'
        ];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/x-www-form-urlencoded'
        ];
        return this.httpClient.get(this.basePath + "/categories_codes", {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    CategoriesCodesService.prototype.categoriesCodesPost = function (body, observe, reportProgress) {
        if (observe === void 0) { observe = 'body'; }
        if (reportProgress === void 0) { reportProgress = false; }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling categoriesCodesPost.');
        }
        var headers = this.defaultHeaders;
        // to determine the Accept header
        var httpHeaderAccepts = [];
        var httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        var consumes = [
            'application/json'
        ];
        var httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(this.basePath + "/categories_codes", body, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    };
    return CategoriesCodesService;
}());
export { CategoriesCodesService };
